import cookies from 'cookies';
import Auth from '@aws-amplify/auth';

export const federatedSignIn = (customProvider: string) => {
  window.addEventListener('beforeunload', pushPKCE);
  Auth.federatedSignIn({ customProvider });
};

// These are values stored by amplify - in the sso workflow we need to move them because cognito does not support wildcard callback urls.
const PKCE_KEYS = ['ouath_pkce_key', 'oauth_state'];

// Copy the values stored in session storage by amplify over to cookie storage so they accessible in the superdomain
export const pushPKCE = () => {
  const { esCookieStorage } = cookies;
  PKCE_KEYS.forEach(key => {
    const value = window.sessionStorage.getItem(key);
    if (value) {
      esCookieStorage.setItem(key, value);
    }
  });
};

// Copy the values stored in cookies to session storage so they accessible in the superdomain
export const popPKCE = () => {
  const { esCookieStorage } = cookies;
  PKCE_KEYS.forEach(key => {
    const value = esCookieStorage.getItem(key);
    if (value) {
      esCookieStorage.removeItem(key);
      window.sessionStorage.setItem(key, value);
    }
  });
};
